import React, { useRef, useEffect, useState } from 'react'
import Typography from '../Typography'
import '../../components/Progressbar/styles.css'

const ProgressBar = ({ progress = 0, title }) => {
  const progressRef = useRef()
  useEffect(() => {
    const progressBar = progressRef.current
    const progressBarWidth = progressBar.clientWidth
    const progressFill = progressBar.children[0]

    const fillWidth = Math.min(
      progressBarWidth,
      (0.07 + progress * 0.93) * progressBarWidth,
    )
    progressFill.style.width = `${fillWidth}px`
  }, [progress])

  return (
    <div className="relative flex flex-col justify-between w-full h-12">
      <div className="absolute top-0 left-0 w-full flex justify-center">
        <Typography className="text-center text-sm text-text_secondary">
          {title}
          {/* Progress: {Math.round(progress * 100)}% */}
        </Typography>
      </div>
      <div
        ref={progressRef}
        className="h-2 absolute bottom-0 left-0 w-full rounded-full bg-neutral_1"
      >
        <div className="h-2 progress-fill rounded-full bg-primary transition duration-200" />
      </div>
    </div>
  )
}

export default ProgressBar
